import store from '@ps/store'
import {
  addDragonBone,
  replaceDragonBone,
} from '@ps/bridge/resource/dragon-bone'
import {
  executeAction,
  getAddDragonBoneAction,
  getReplaceDragonBoneAction,
} from '@ps/workbench/undo-redo'
import { scripts } from '@ps/bridge/qc/scripts'
import { EventBus, Event } from '@ps/utils/event-bus'
import { getScript } from '@ps/bridge/qc/scripts/dragon-bone'
import { resetSkPlayerData } from '@ps/bridge/qc/scripts/vertical-horizontal'
import {
  addDragonBoneNode,
  replaceDragonBoneNode,
} from '@ps/bridge/qc/node/dragon-bone'
import { wrapAddIvNode } from '@ps/store/interactive-video/brain/brain'

function autoPlay(node) {
  const sk = getScript(node)
  if (sk && sk.playOnAwake) {
    setTimeout(() => {
      sk.play && sk.play()
    }, 0)
  }
}
export default {
  async addDragonBone({ state }, { data, isPool = false, isAddNode = true }) {
    const sceneNode = store.state.workspace.sceneManager.currentSceneNode
    const activeNode = state.activeNode
    let node = null
    if (isPool) {
      node = await addDragonBoneNode({
        binUUID: data.binUUID,
        pid: store.state.workspace.pid,
        sceneNode,
        nodeName: data.name,
        name: data.name,
      })
    } else {
      node = await addDragonBone({
        data,
        pid: store.state.workspace.pid,
        sceneNode,
        isAddNode,
      })
      // 只添加龙骨到项目资产，不添加到场景
      if (!isAddNode) return
    }
    node.addScript(scripts.dragonBone.name)
    EventBus.$emit(Event.REFRESHLAYER)
    EventBus.$emit(Event.ADD_GAME_OBJECT, node.uuid)
    autoPlay(node)
    resetSkPlayerData(node)
    const index = sceneNode.getChildIndex(node)
    if (index >= 0) {
      // 互动视频编辑器插入节点处理
      const ivRes = await wrapAddIvNode(sceneNode, node, index)

      await executeAction({
        action: getAddDragonBoneAction({
          newValue: {
            node: ivRes ? ivRes.ivGroupNode : node,
            realNode: node,
            parent: sceneNode,
            index: ivRes ? ivRes.index : index,
          },
          oldValue: {
            node: ivRes ? ivRes.ivGroupNode : node,
            activeUuid: activeNode ? activeNode.uuid : '',
          },
        }),
        record: true,
      })
      return true
    }
    return false
  },

  async replaceDragonBone({ state }, { data, node, isPool = false }) {
    const nodes = Array.isArray(node) ? node : [node || state.activeNode]
    const taskList = nodes.map(async (node) => {
      const activeNode = node || state.activeNode
      const sk = getScript(activeNode)
      const { loop, delay, speed, animationName, playOnAwake } = sk || {}
      const oldResourceUuid =
        (activeNode.texture && activeNode.texture.atlas.uuid) || ''
      let asset = ''
      if (isPool) {
        asset = await replaceDragonBoneNode({
          binUUID: data.binUUID,
          pid: store.state.workspace.pid,
          nodeName: data.name,
          name: data.name,
          activeNode,
        })
      } else {
        asset = await replaceDragonBone({
          data,
          pid: store.state.workspace.pid,
          activeNode,
        })
      }
      return {
        node: activeNode,
        asset,
        oldResourceUuid,
        loop,
        delay,
        speed,
        animationName,
        playOnAwake,
      }
    })
    const res = await Promise.all(taskList)
    const newValueArr = res.map((item) => {
      return {
        node: item.node,
        resourceUuid: item.asset.uuid,
      }
    })
    const oldValueArr = res.map((item) => {
      return {
        node: item.node,
        resourceUuid: item.oldResourceUuid,
        sk: {
          loop: item.loop,
          delay: item.delay,
          speed: item.speed,
          animationName: item.animationName,
          playOnAwake: item.playOnAwake,
        },
      }
    })
    await executeAction({
      action: getReplaceDragonBoneAction({
        newValue: newValueArr,
        oldValue: oldValueArr,
      }),
      record: true,
    })
    if (nodes.length === 1) {
      autoPlay(nodes[0])
    }
  },
}
